import { render } from "./NewDonor.vue?vue&type=template&id=7a4bf4d6&scoped=true"
import script from "./NewDonor.vue?vue&type=script&lang=js"
export * from "./NewDonor.vue?vue&type=script&lang=js"

import "./NewDonor.vue?vue&type=style&index=0&id=7a4bf4d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4bf4d6"]])

export default __exports__